import React, { useCallback, useState } from "react";
import styled from "styled-components";
import { theme } from "@workboard/wobo-ui";
import ChartOKRs from "../components/ChartOKRs";
import TableBreakdown from "../components/TableBreakdown";
import OwnerSelector from "../components/OwnerSelector";

const Content = styled("section")``;

const EngagementReportTeams = ({ className }) => {
  const [id, setId] = useState();
  const [name, setName] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const handleChange = useCallback(
    (ev) => {
      const { id, label } = ev || {};
      if (!id && !label) {
        setIsLoading(false);
        return;
      }
      if (id) setId(id);
      if (label) setName(label);
    },
    []
  );

  return (
    <div className={className}>
      <OwnerSelector onChange={handleChange} />
      <Content>
        { /*<ChartOKRs id={id} /> Post-wave63 */}
        <TableBreakdown id={id} name={name} isLoading={isLoading}/>
      </Content>
    </div>
  );
};

export default styled(EngagementReportTeams)`
  font-family: ${theme("--font")};

  ${Content} {
    background-color: #f1f3f5;
    /* display: grid; Post-wave63 */
    grid-gap: 24px 0;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(4, 1fr);
    height: calc(100vh - 110px);
    /* padding: 28px 24px; Post-wave63 */
    padding: 0px 24px 28px;
  }

  ${ChartOKRs} {
    grid-row: 1;
    grid-column: span 12;
  }

  ${TableBreakdown} {
    grid-row: 2;
    grid-column: span 12;
  }
`;
